import './froala_description_editor.less';
import 'zoomforth_component_lib/froala_theme_vanilla.less';

import React from 'react';

import FroalaEditor from 'zoomforth_component_lib/froala_editor.jsx';
import { focusAtEnd } from 'zoomforth_component_lib/froala_editor.jsx';
import { getLinkStyleOptions } from 'zoomforth_component_lib/froala_editor.jsx';


export default ({ config, ...props })=> (
  <FroalaEditor
    className="froala-medialib-description-editor"
    config={{
      theme: 'vanilla',
      typingTimer: 250,
      placeholderText: '',
      tabSpaces: 4,
      paragraphFormatSelection: true,
      linkList:[], // Make sure we dont offer any predefined links for choosing
      linkStyles: getLinkStyleOptions(),
      linkMultipleStyles: false,
      events: {
        'initialized': focusAtEnd
      },
      paragraphFormat: {
        N: 'P',
        H1: 'H1',
        H2: 'H2',
        H3: 'H3',
        H4: 'H4'
      },
      heightMax: '200px',
      initOnClick: false,
      ...config
    }}
    {...props}
  />
);

